import { BLUE_RIBBON_POT_STATE } from './../common/interfaces/blue-ribbon-party-jackpot.interface';
import {GameRawData} from "./services/sdk/sdk.service.interface";

export const B2C_APP_ID: string = "B2C";

export interface GetGamesInfoResponse {
    foundGames: {[key: number]: any};
    missingGames: number[];
}

export interface IUserInfo {
    readonly isAuthorized: boolean;
}

export interface ISiteInfo {
    readonly brandId: number;
    readonly subBrandId: number;
}

export interface IClientInfo {
    readonly fullVersion: string;
}

export interface PartyJackpotInfo {
    id: string;
    name: string;
    amount: string;
    mustHitTime: Date;
    isActive: boolean;
    status: BLUE_RIBBON_POT_STATE;
    games: number[];
}

export interface IOrbitApi {
    readonly version: string;
    readonly userInfo: IUserInfo;
    readonly siteInfo: ISiteInfo;
    readonly clientInfo: IClientInfo;

    deepLink(deepLinkObject: any, navigate?: any): any;

    getMarketingData(marketingParams): any;

    sendAnalytics(cat?, action?, label?, value?): void;

    showPwaPrompt(): any;

    isPwaInstallable(): any;

    getGamesInfo(gameTypes: number[]): Promise<GetGamesInfoResponse>;

    getGamesWithoutBonus(): Promise<GameRawData>;

    onBlueRibbonPartyJackpotUpdate(fn: (data: PartyJackpotInfo) => void);
    getRefreshToken(): string;
}
